import React, { useEffect, useState } from "react";
import { FaPlus, FaUserDoctor } from "react-icons/fa6";
import DoctorModal from "../../Modal/DoctorModal/DoctorModal";
import { useDispatch, useSelector } from "react-redux";
import { MdEdit } from "react-icons/md";
import { RxUpdate } from "react-icons/rx";
import { IoClose } from "react-icons/io5";
import {
  getSurgeryAction,
  updateSurgeryAction,
} from "../../Actions/SurgeryAction/SurgeryAction";
import SurgeryModal from "../../Modal/SurgeryModal/SurgeryModal";
import LoadingPage from "../Loading/LoadingPage";

const Surgery = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const getSurgery = useSelector((state) => state.getSurgery);
  const { surgeries, loading } = getSurgery;
  const dispatch = useDispatch();
  const [indexx, setIndexx] = useState(null);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [inputValue, setInputValue] = useState({
    surgery_id: "",
    name: "",
    status: "",
  });

  const [debounceValue, setDebounceValue] = useState(null);
  const [surgeryName, setSurgeryName] = useState();
  useEffect(() => {
    if (debounceValue !== null) {
      dispatch(getSurgeryAction(debounceValue));
    }
  }, [debounceValue]);
  
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(surgeryName);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [surgeryName]);

  const handleEdit = (id, name, index) => {
    setInputValue({
      ...inputValue,
      name: name,
      surgery_id: id,
    });
    setIndexx(index);
    setIsOpenUpdate(true);
  };
  const handleClose = () => {
    setIndexx(null);
    setIsOpenUpdate(false);
  };
  const handleUpdate = () => {
    dispatch(updateSurgeryAction(inputValue.surgery_id, inputValue.name));
    setIndexx(null);
    setIsOpenUpdate(false);
  };
  return (
    <>
      <div className="parent">
        <div className="flex justify-between gap-2 px-2 items-center">
          <div className="flex gap-1 items-center font-bold text-blue-600">
            <FaUserDoctor />
            <p>Doctors</p>
          </div>
          <div className="mt-1">
            <button
              className="btn-primary flex gap-2 items-center"
              onClick={() => setIsOpenModal(true)}
            >
              <p>Add Surgery</p>
              <FaPlus />
            </button>
          </div>
        </div>
        <div className="w-5/12 m-auto">
          <input
            type="text"
            className="input w-full"
            placeholder="Search By Surgery Name"
            onChange={(e) => setSurgeryName(e.target.value)}
            value={surgeryName}
          />
        </div>
        {loading ? (
          <LoadingPage />
        ) : (
          <div className="parent-table">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Surgery</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {surgeries?.map((surgery, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {indexx == index && isOpenUpdate ? (
                          <input
                            type="text"
                            className="input w-full"
                            placeholder="Name"
                            onChange={(e) => {
                              setInputValue({
                                ...inputValue,
                                name: e.target.value,
                              });
                            }}
                            value={inputValue.name}
                          />
                        ) : (
                          surgery.name
                        )}
                      </td>
                      <td>
                        {indexx == index && isOpenUpdate ? (
                          <div className="flex gap-2  items-center">
                            <button
                              onClick={handleUpdate}
                              className="btn-primary flex gap-2 items-center"
                            >
                              Update <RxUpdate />
                            </button>
                            <button
                              onClick={handleClose}
                              className="btn-danger flex gap-2 items-center"
                            >
                              Close <IoClose />{" "}
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => {
                              handleEdit(surgery.id, surgery.name, index);
                            }}
                            className="btn-warning   flex items-center gap-2"
                          >
                            Edit <MdEdit />
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {isOpenModal && (
          <SurgeryModal closeModal={() => setIsOpenModal(false)} />
        )}
        <div className="pb-10"></div>
      </div>
    </>
  );
};

export default Surgery;
